import { render, staticRenderFns } from "./CurrentSettledGoods.vue?vue&type=template&id=a17267ae&scoped=true&"
import script from "./CurrentSettledGoods.vue?vue&type=script&lang=js&"
export * from "./CurrentSettledGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17267ae",
  null
  
)

export default component.exports